<template>
  <hi-list :items="campaignList" @select="select">
    <template v-slot="{ item }">
      <v-list-item-content>
        <v-list-item-title
          ><h3>{{ item.name }}</h3></v-list-item-title
        >
        <v-list-item-subtitle class="ui-text-italic"
          >Created on {{ item.dateCreated | timestamp(true)
          }}{{
            item.scheduled ? "Draft" : item.scheduled
          }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </template>
  </hi-list>
</template>

<script>
import { db } from "@/db";
import HiList from "@/components/HiList";

export default {
  name: "SmsCampaignList",
  components: { HiList },
  data() {
    return {
      campaignList: [],
      selected: null
    };
  },
  firestore: {
    campaignList: db.collection("sms/bulk/campaigns")
  },
  methods: {
    select(item) {
      console.log(item);
      this.$emit("select", item);
    }
  }
};
</script>

<style scoped></style>
